import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "check-ligne"
}
const _hoisted_2 = ["width"]
const _hoisted_3 = ["width"]
const _hoisted_4 = {
  key: 2,
  class: "mails"
}
const _hoisted_5 = ["src", "onClick"]
const _hoisted_6 = { class: "add" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_content_loader = _resolveComponent("content-loader")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_ButtonBlue = _resolveComponent("ButtonBlue")!
  const _component_ModalCard = _resolveComponent("ModalCard")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, { onCancel: _ctx.cancel }, {
    default: _withCtx(() => [
      _createVNode(_component_ModalCard, {
        onCancel: _ctx.cancel,
        headerTitle: _ctx.$t('modale.options.suivi.di.title'),
        withoutBotNav: true,
        "active-validate": false,
        id: "loadingdiv"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass({ disabled: !_ctx.suiviActif })
          }, [
            (!_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_component_CheckBox, {
                    checked: _ctx.suiviActif,
                    label: _ctx.$t('modale.options.suivi.di.enable'),
                    onClickCheck: _ctx.toggleSuivi
                  }, null, 8, ["checked", "label", "onClickCheck"]),
                  _createVNode(_component_ReglePastille, { cle: "optionsInterventions.desactivationGlobale" })
                ]))
              : (_openBlock(), _createBlock(_component_content_loader, {
                  key: 1,
                  width: _ctx.width,
                  height: _ctx.listHeight
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("rect", {
                      x: "0",
                      y: "0",
                      rx: "3",
                      ry: "3",
                      width: _ctx.width/2,
                      height: "15"
                    }, null, 8, _hoisted_2),
                    _createElementVNode("rect", {
                      x: "0",
                      y: "35",
                      rx: "3",
                      ry: "3",
                      width: _ctx.width,
                      height: "40"
                    }, null, 8, _hoisted_3)
                  ]),
                  _: 1
                }, 8, ["width", "height"])),
            (!_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailsSuivi, (email) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "line",
                      key: email.id
                    }, [
                      _createVNode(_component_CheckBox, {
                        checked: email.actif,
                        label: email.email,
                        onClickCheck: ($event: any) => (_ctx.toggleEmailActif(email)),
                        disabled: !_ctx.suiviActif || (!email.actif && _ctx.emailInputDisabled)
                      }, null, 8, ["checked", "label", "onClickCheck", "disabled"]),
                      _createElementVNode("img", {
                        class: _normalizeClass(["trash-icon", { disabled: !_ctx.suiviActif, enabled: _ctx.suiviActif}]),
                        src: _ctx.deleteIcon,
                        alt: "delete",
                        onClick: ($event: any) => (_ctx.deleteEmail(email))
                      }, null, 10, _hoisted_5)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_TextInput, {
                class: "input",
                modelValue: _ctx.newEmail,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newEmail) = $event)),
                label: _ctx.inputLabel,
                disabled: _ctx.emailInputDisabled
              }, null, 8, ["modelValue", "label", "disabled"]),
              _createVNode(_component_ButtonBlue, {
                text: _ctx.$t('modale.options.suivi.di.add.button'),
                "on-click": _ctx.addEmail,
                disabled: _ctx.emailButtonDisabled
              }, null, 8, ["text", "on-click", "disabled"]),
              _createVNode(_component_ReglePastille, { cle: "optionsInterventions.formatEmail" }),
              _createVNode(_component_ReglePastille, { cle: "optionsInterventions.maxEmails" })
            ])
          ], 2)
        ]),
        _: 1
      }, 8, ["onCancel", "headerTitle"])
    ]),
    _: 1
  }, 8, ["onCancel"]))
}